import React from "react";
import {Box, Stack, Typography} from "@mui/material";
import {barFraction, RANK_MAX, rankLevel} from "~/pages/spend-landscape/components/chartHelpers";

/**
 * Opportunity rank as a coloured bar (green high, amber medium, red low) and its value.
 */
export const OpportunityRankCell: React.FC<{rank: number | null | undefined}> = ({rank}) => {
    if (rank === null || rank === undefined || !Number.isFinite(rank)) return <>-</>;
    const level = rankLevel(rank);
    return <Stack direction="row" alignItems="center" gap={1} sx={{height: '100%'}}>
        <Box className="opportunity-rank-bar" aria-hidden>
            <Box className={`opportunity-rank-fill ${level}`} sx={{width: `${barFraction(rank, RANK_MAX) * 100}%`}}/>
        </Box>
        <Typography variant="body2" className="tabular" title={`Opportunity rank ${rank.toFixed(2)} (${level})`}>
            {rank.toFixed(2)}
        </Typography>
    </Stack>;
};
